<template>
  <a-form :form="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
    <div class="filWrap">
      <span
        ><span style="color: #333">Language filtering:</span
        ><a-dropdown :trigger="['click']">
          <a class="dropdown-a" @click="e => e.preventDefault()"
            >{{ languageData[language] }} <a-icon class="down-icon" type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item :key="index" v-for="(item, index) in languageData" @click="languageFn(index)">
              {{ item }}
            </a-menu-item>
          </a-menu>
        </a-dropdown></span
      >
    </div>
    <a-form-item label="File name">
      <a-input
        :maxLength="200"
        @change="e => nameChange(e)"
        v-decorator="['name', { rules: [{ required: true, message: 'Please enter a file name' }] }]"
      />
      <TortBrandList :detail="record" :language="language"></TortBrandList>
    </a-form-item>
    <a-form-item label="Label name">
      <div class="in-wrap" :key="tagIndex">
        <template v-for="(it, i) in record.tags">
          <a :key="i" v-if="it">
            {{ it }}
            <b class="icon-operation_close" @click="deleteTab(i, record)">x</b>
          </a>
        </template>
        <a-input
          allowClear
          style="width: 160px;"
          v-model="tagValue"
          placeholder="Enter enter to add"
          @pressEnter="
            () => {
              tabFn(record)
            }
          "
        ></a-input>
      </div>
      <div>
        <a-select
          v-model="record.tagsModel"
          @change="
            () => {
              tagsModelFn(record)
            }
          "
          placeholder="Select an existing label"
        >
          <a-select-option value=""><span style="color: #999">Select an existing label</span></a-select-option>
          <a-select-option :value="value.tags" v-for="(value, index) in allTags" :key="index">{{
            value.tags
          }}</a-select-option>
        </a-select>
      </div>
      <TortBrandList :detail="record" :language="language" :isLabel="true"></TortBrandList>
    </a-form-item>
  </a-form>
</template>

<script>
import { languageData } from '@/utils/const'
import TortBrandList from './tortBrandList'
import { mapState } from 'vuex'
export default {
  name: 'EditText',
  data() {
    return {
      language: 1,
      record: {},
      tagValue: '',
      tagIndex: 1,
      languageData: languageData,
      form: this.$form.createForm(this, { name: 'editText' }),
      id: ''
    }
  },
  components: { TortBrandList },
  computed: {
    ...mapState({
      allTags: state => state.myGallery.allTags
    })
  },
  methods: {
    tagsModelFn(item) {
      console.log('item==', item)
      if (!item.tagsModel) {
        return
      }
      item.tags.push(item.tagsModel)
      this.tagIndex++
    },
    tabFn(item) {
      console.log('item===', item)
      if (!this.tagValue) {
        return
      }
      item.tags.push(this.tagValue)
      this.tagValue = ''
      this.tagIndex++
    },
    deleteTab(i, item) {
      item.tags.splice(i, 1)
      this.tagIndex++
    },
    languageFn(index) {
      if (this.language !== index) {
        this.language = index
        this.form.setFieldsValue({
          name: this.record.material_name_alias[this.language]
        })
      }
    },
    nameChange(e) {
      this.record.material_name_alias[this.language] = e.target.value
    }
  },
  mounted() {}
}
</script>

<style scoped lang="less">
.filWrap {
  margin-bottom: 20px;
  text-align: right;
}
.in-wrap {
  border: 1px solid #ccc;
  padding: 8px;
  color: #555;
  // border-radius: 4px;
  line-height: 1.4;
  a {
    padding: 3px 5px;
    background-color: #d4eaff;
    border-radius: 3px;
    cursor: pointer;
    display: inline-block;
    color: #428bca;
    text-decoration: none;
    margin: 1px 0;
    margin-right: 5px;
    .icon-operation_close {
      font-weight: normal;
      font-size: 14px;
      color: #333;
    }
  }
}
</style>
